import AbstractValidator from './AbstractValidator';

export default class Between extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notBetween: 'Der Eingabewert liegt nicht zwischen \'%min%\' und \'%max%\', diese Werte mit eingeschlossen',
        notBetweenStrict: 'Der Eingabewert liegt nicht zwischen \'%min%\' und \'%max%\'',
    };

    run()
    {
        let number    = this.value;
        let min       = this._options.min;
        let max       = this._options.max;
        let inclusive = !!this._options.inclusive;

        let numberString = '' + this.value;

        if (numberString.length > 2 && numberString.indexOf('.') === -1)
        {
            if (numberString.indexOf(',') !== -1)
            {
                number = parseFloat(numberString.replace(',', '.'));
            }
            else if (numberString.indexOf(':') !== -1)
            {
                let [hours, minutes] = numberString.split(':').map(Number);
                number               = hours + (minutes / 60);
            }
        }

        if (inclusive && (min > number || number > max))
        {
            this.error = this.getMessage('notBetween');
        }
        else if (!inclusive && (min >= number || number >= max))
        {
            this.error = this.getMessage('notBetweenStrict');
        }
    }
}